function getDataTestId(component_name, displayType, uniqueId) {
  if (displayType && uniqueId) {
    return `${component_name}_${displayType}_${uniqueId}`;
  }
  if (displayType) {
    return `${component_name}_${displayType}`;
  }
  if (uniqueId) {
    return `${component_name}_${uniqueId}`;
  }
  return component_name;
}
const listMissingVariables = (variables) => {
  const missing = [];
  for (const name in variables) {
    if (variables[name] === void 0) {
      missing.push(name);
    }
  }
  return missing.join(", ");
};
export {
  getDataTestId,
  listMissingVariables
};
